import { publicRequest } from "../core/services";
const search = {
    content: (data) => publicRequest.post("/api/search/search-content-list", data),
    tag: (data) => publicRequest.post("/video/search", data),
};
export const api = {
    search,
};
